import { createContext, useContext } from 'react';

import { type FooterMoreRowDescriptor } from '../footer-rail/footer-rail-context';

export interface PrimaryNavRailState {
  /** IDs committed as collapsed (triggers DOM unmount in PrimaryNavFixedItem). */
  collapsedIds: ReadonlySet<string>;
  /** IDs currently playing their height-collapse exit animation. */
  collapsingIds: ReadonlySet<string>;
  moreDescriptors: readonly FooterMoreRowDescriptor[];
  /** Whether any more descriptor is currently active. */
  isMoreActive: boolean;
  /** Ref callback for the More trigger element — used to anchor the ResizeObserver. */
  containerRef: (el: HTMLElement | null) => void;
}

const defaultState: PrimaryNavRailState = {
  collapsedIds: new Set(),
  collapsingIds: new Set(),
  moreDescriptors: [],
  isMoreActive: false,
  containerRef: () => {},
};

export const PrimaryNavRailContext = createContext<PrimaryNavRailState>(defaultState);

export const usePrimaryNavRail = (): PrimaryNavRailState =>
  useContext(PrimaryNavRailContext);
